module.exports = __webpack_public_path__ + "93ebf4504d2347c56b93ab213d58ddff.svg";